import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './original.css';
import './custom.css';
import './theme.css';
import './theme-polish.css';
import './theme-readability.css';
import './theme-effects.css';
import './theme-hero-fix.css';
import './theme-hero-premium.css';
import './footer-premium.css';
import './theme-performance.css';
import './theme-readability-final.css';
import './theme-home-showcase.css';
import './theme-packages-premium.css';
import './navbar-premium.css';
import './design-system.css';
import './admin/admin-theme.css';

// Prerender (react-snap) HTML ile client render uyumsuzluğu hydration hatası (#418) veriyordu.
// Canlıda kararlı çalışması için doğrudan client render kullanıyoruz.
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
root.render(<App />);
